<template>
  <div>
    <vs-card>
      <b-row>
        <b-col class="p-5">
          <b-row v-if="ROLE != 'Company'">
            <b-col cols="3" align-self="center">
              <b-form-group
                :label="'* ' + $t('Customer')"
                label-for="h-first-name"
                style="font-weight: bold; font-size: larger"
              >
              </b-form-group>
            </b-col>
            <b-col cols="9">
              <v-select
                color="danger"
                v-model="customer"
                :options="customer_choices"
                size="small"
                label="name"
                autocomplete
                ref="selectElement"
                name="customer"
                v-validate="'required'"
              >
              </v-select>

              <span class="text-danger text-sm" v-show="errors.has('customer')">{{
                errors.first("customer")
              }}</span>
            </b-col>
          </b-row>
          <b-row style="margin-top: 8px">
            <b-col cols="3" align-self="center">
              <b-form-group
                :label="$t('ReportShemaName')"
                label-for="h-first-name"
                style="font-weight: bold; font-size: larger"
              >
              </b-form-group>
            </b-col>
            <b-col cols="9">
              <vs-input
                size="small"
                v-model="reportShemaName"
                type="text"
                name="reportShemaName"
                v-validate="'required'"
                class="w-full"
              />
              <span class="text-danger text-sm" v-show="errors.has('reportShemaName')">{{
                errors.first("reportShemaName")
              }}</span>
            </b-col>
          </b-row>
          <b-row style="margin-top: 8px">
            <b-col cols="3" align-self="center">
              <b-form-group
                :label="$t('ReportShemaDescription')"
                label-for="h-first-name"
                style="font-weight: bold; font-size: larger"
              >
              </b-form-group>
            </b-col>
            <b-col cols="9">
              <vs-textarea v-model="reportShemaDescription"></vs-textarea>
            </b-col>
          </b-row>
          <b-row style="margin-top: 8px">
            <b-col cols="3" align-self="center">
              <b-form-group
                :label="$t('ReportShemaQuery')"
                label-for="h-first-name"
                style="font-weight: bold; font-size: larger"
              >
              </b-form-group>
            </b-col>
          </b-row>
          <vs-textarea v-model="reportShemaQuery"></vs-textarea>
          <div class="items-center pl-6 mt-5 mb-0">
            <b-row align-h="end">
              <!--
              <b-col cols="3" md="auto" style="padding: 0px">
                <b-button
                  class="bg-success"
                  style="border-color: white"
                  v-on:click="runReport()"
                  :disabled="reportShemaId == ''"
                >
                  <Icon
                    icon="solar:play-bold"
                    style="margin-right: 5px"
                    width="20"
                    height="20"
                  />{{ $t("Run") }}
                </b-button>
              </b-col>-->
              <b-col cols="3" md="auto" style="padding: 0px">
                <b-button
                  class="bg-danger"
                  style="border-color: white"
                  v-on:click="cancelReport()"
                >
                  <Icon
                    icon="material-symbols:cancel-outline"
                    style="margin-right: 5px"
                    width="20"
                    height="20"
                  />{{ $t("Cancel") }}
                </b-button>
              </b-col>
              <b-col cols="3" md="auto">
                <b-button
                  class="bg-primary"
                  style="border-color: white"
                  v-on:click="submitData()"
                >
                  <Icon
                    icon="material-symbols:save-outline"
                    style="margin-right: 5px"
                    width="20"
                    height="20"
                  />{{ $t("Save") }}
                </b-button>
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col>
          <ag-grid-vue
            ref="agGridTable"
            class="scroll-to-ag-grid-table ag-theme-alpine w-100 my-4 ag-grid-table"
            :columnDefs="columns"
            :defaultColDef="defaultColDef"
            :rowData="processList"
            rowSelection="multiple"
            colResizeDefault="shift"
            :animateRows="true"
            :pagination="true"
            @grid-ready="onGridReady"
            :suppressCopyRowsToClipboard="true"
            :localeText="localeText"
            :suppressRowClickSelection="true"
            @first-data-rendered="onFirstDataRendered"
          >
          </ag-grid-vue>
        </b-col>
      </b-row>
    </vs-card>
    <vs-prompt
      :title="$t('Warning')"
      :acceptText="$t('Submit')"
      :cancelText="$t('Cancel')"
      @accept="deleteReportSb"
      :active.sync="isSidebarActiveProcess"
      color="danger"
    >
      <div style="text-align: center" class="con-exemple-prompt">
        <span>
          <b-row style="margin-top: 15px">
            <b-col cols="12" align-self="center">
              <h6>{{ $t("DoConfirm") }}</h6>
            </b-col>
          </b-row>
        </span>
      </div>
    </vs-prompt>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import { Icon } from "@iconify/vue2";
import i18nData from "../../i18n/i18nData";
import { uuid } from "vue-uuid";
import threeInfoButtonsDynamic from "../CellRenderers/threeInfoButtonsDynamic.vue";
import moment from "moment";
export default {
  data() {
    return {
      isSidebarActiveProcess: false,
      infoData: [],
      customer: "",
      customer_choices: [],
      ROLE: this.$store.state.AppActiveUser.ROLE,
      reportShemaName: "",
      reportShemaDescription: "",
      reportShemaQuery: "",
      reportShemaId: "",
      processList: [],
      defaultColDef: {
        sortable: true,
        editable: true,
        resizable: true,
      },
      columns: [],
    };
  },
  components: {
    threeInfoButtonsDynamic,
    uuid,
    vSelect,
    AgGridVue,
    Icon,
  },
  methods: {
    deleteReportSb() {
      const vs = this.$vs;
      this.$store
        .dispatch("report/deleteReport", this.infoData.ReportShemaId)
        .then((response) => {
          if (response.status == 200) {
            try {
              vs.notify({
                text: response.data.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
              this.addReportData();
            } catch (error) {
              console.log(error);
            }
          } else
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
        })
        .catch((error) => {
          console.log(error);
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },
    deleteReport() {
      this.isSidebarActiveProcess = true;
    },
    runReport() {
      const vs = this.$vs;
      let obj = {
        companyId: this.infoData.CompanyId,
        name: this.infoData.ReportShemaName,
      };
      this.$store
        .dispatch("report/runReports", obj)
        .then((response) => {
          if (response.success == true) {
            vs.notify({
              text: response.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });
          } else {
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
          }
        })
        .catch((error) => {
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },
    submitData() {
      var createdId = uuid.v4();
      const vs = this.$vs;
      let method = "addReport";
      this.$validator.validateAll().then((result) => {
        if (result) {
          let obj = {
            reportShemaId: createdId,
            reportShemaName: this.reportShemaName,
            reportShemaDescription: this.reportShemaDescription,
            reportShemaQuery: this.reportShemaQuery,
            companyId: this.customer.value,
            companyName: this.customer.name,
          };
          if (this.reportShemaId) {
            method = "updateReports";
            obj = {
              reportShemaId: this.reportShemaId,
              reportShemaName: this.reportShemaName,
              reportShemaDescription: this.reportShemaDescription,
              reportShemaQuery: this.reportShemaQuery,
              companyId: this.customer.value,
              companyName: this.customer.name,
            };
          }
          this.$store
            .dispatch("report/" + method, obj)
            .then((response) => {
              if (response.status == 200) {
                vs.notify({
                  text: response.data.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                  position: "top-center",
                });
                this.cancelReport();
                this.addReportData();
              } else {
                vs.notify({
                  text: response.data.message.toString(),
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                  position: "top-center",
                });
              }
            })
            .catch((error) => {
              return new Promise((resolve, reject) => {
                resolve(false);
              });
            });
        } else {
          vs.notify({
            text: this.$t("Validate"),
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-center",
          });
        }
      });
    },
    editReport() {
      this.reportShemaName = this.infoData.ReportShemaName;
      this.reportShemaDescription = this.infoData.ReportShemaDescription;
      this.reportShemaQuery = this.infoData.ReportShemaQuery;
      this.reportShemaId = this.infoData.ReportShemaId;
      this.customer = {
        name: this.infoData.CompanyName,
        value: this.infoData.CompanyId,
      };
    },
    cancelReport() {
      this.reportShemaName = "";
      this.reportShemaDescription = "";
      this.reportShemaQuery = "";
      this.reportShemaId = "";
      this.customer = "";
    },
    getCustomerList(id, popup) {
      this.customerListOption = [];
      this.customer_choices = [];
      this.customerListOption = this.companydata;
      this.customerListOption.forEach((val, index) => {
        this.customer_choices.push({ value: val.CompanyId, name: val.CompanyName });
      });
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      var defaultSortModel = [{ colId: "CompanyName", sort: "asc", sortIndex: 0 }];
      params.columnApi.applyColumnState({ state: defaultSortModel });
      this.gridApi.refreshCells(params);
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    getReportsColumnList() {
      this.columns = [];

      if (this.processList.length > 0) {
        let columnList = Object.keys(this.processList[0]);
        this.columns.push({
          width: 200,
          pinned: "left",
          cellRendererFramework: "threeInfoButtonsDynamic",
          cellRendererParams: {
            detailMethodsOne: "runReport",
            iconDetailOne: "solar:play-bold",
            iconColorOne: "#17c3b2",
            tooltipOne: "Run",
            detailMethodsTwo: "editReport",
            iconDetailTwo: "material-symbols:edit",
            iconColorTwo: "#065a82",
            tooltipTwo: "Edit",
            detailMethodsTree: "deleteReport",
            iconDetailTree: "ic:baseline-remove-circle",
            iconColorTree: "#fe6d73",
            tooltipTree: "delete",
          },
        });
        columnList.forEach((val, index) => {
          if (val == "CompanyName") {
            this.columns.push({
              pinned: "left",
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
            });
          } else if (val.toString().includes("Date") == true)
            this.columnsProcess.push({
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
              valueFormatter: (params) => this.parseDate(params.data[val]),
              editable: true,
            });
          else if (val.toString().includes("Id") == false) {
            this.columns.push({
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
            });
          }
        });
      }
    },
    parseDate(params) {
      return moment(String(params)).format("DD.MM.YYYY");
    },
    addReportData() {
      const vs = this.$vs;

      this.$store
        .dispatch("report/listReports")
        .then((response) => {
          if (response.success == true) {
            try {
              this.getReportsColumnList();
            } catch (error) {
              console.log(error);
            }
          } else
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
        })
        .catch((error) => {
          console.log(error);
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },
  },
  computed: {
    companydata: {
      get() {
        return this.$store.state.customer.Customer;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    localeText() {
      return i18nData[this.$i18n.locale];
    },
    reports: {
      get() {
        return this.$store.state.report.Reports;
      },
      set(val) {
        if (!val) {
        }
      },
    },
  },
  created() {
    this.addReportData();
    this.getCustomerList();
  },
  watch: {
    companydata(val) {
      this.getCustomerList();
      return val;
    },
    reports(val) {
      if (val.length > 0) {
        this.processList = val;
      }
      return val;
    },
  },
  mounted() {
    this.$root.$on("runReport", (data) => {
      this.infoData = data;
      this.runReport();
    });
    this.$root.$on("editReport", (data) => {
      this.infoData = data;
      this.editReport();
    });
    this.$root.$on("deleteReport", (data) => {
      this.infoData = data;
      this.deleteReport();
    });
  },
  beforeDestroy() {
    this.$root.$off("runReport");
    this.$root.$off("editReport");
    this.$root.$off("deleteReport");
  },
};
</script>
<style lang="scss" scoped>
.scroll-to-ag-grid-table {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 110px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
